import {DatePicker} from 'antd';
import CountUp from "react-countup";
import {BadgePlus, BadgeCheck, BadgeX, HeartHandshake, BadgePercent} from "lucide-react";
import dayjs, {Dayjs} from "dayjs";
import "./AnalyticsCard.scss";

const {RangePicker} = DatePicker;

const AnalyticsCard = ({
                           t,
                           title,
                           created,
                           success,
                           failure,
                           tips,
                           successPercent,
                           isShowDate,
                           handleChangePeriod,
                           avgIncome = null
                       }) => {
    const disabledDate = (current) => {
        return dayjs().add(1, 'day') < current;
    };

    return (
        <div className="s2p-analysis-card">
            <div className="s2p-analysis-card__header">
                <h3 className="s2p-analysis-card__title">{title}</h3>
                {isShowDate && (
                    <RangePicker
                        // presets={usePeriodPresets()}
                        defaultValue={[
                            dayjs().startOf('day'),
                            dayjs().add(1, 'day').startOf('day')
                        ]}
                        onChange={handleChangePeriod}
                        disabledDate={disabledDate}
                        allowClear={false}
                    />
                )}
            </div>
            <div className="s2p-analysis-card__stats">
                <div className="stat created">
                    <BadgePlus className="icon"/>
                    {avgIncome ? (
                        <div className="stat-info">
                            <span className="label">{t("pages.scan2pay.analysis.label4")}</span>
                            <span className="value">
                                <CountUp end={avgIncome} duration={3}/>
                            </span>
                        </div>
                    ) : (
                        <div className="stat-info">
                            <span className="label">{t("pages.scan2pay.analysis.label6")}</span>
                            <span className="value">
                                <CountUp end={created} duration={3}/>
                            </span>
                        </div>
                    )}
                </div>
                <div className="stat success">
                    <BadgeCheck className="icon"/>
                    <div className="stat-info">
                        <span className="label">{t("pages.scan2pay.analysis.label1")}</span>
                        <span className="value">
                            <CountUp end={success} duration={3}/>
                        </span>
                    </div>
                </div>
                <div className="stat failure">
                    <BadgeX className="icon"/>
                    <div className="stat-info">
                        <span className="label">{t("pages.scan2pay.analysis.label2")}</span>
                        <span className="value">
                            <CountUp end={failure} duration={3}/>
                        </span>
                    </div>
                </div>
                <div className="stat tips">
                    <HeartHandshake className="icon"/>
                    <div className="stat-info">
                        <span className="label">{t("pages.scan2pay.analysis.label5")}</span>
                        <span className="value">
                            <CountUp end={tips} duration={3}/>
                        </span>
                    </div>
                </div>
                {successPercent !== null && successPercent !== undefined && (
                    <div className="stat success_percent">
                        <BadgePercent className="icon"/>
                        <div className="stat-info">
                            <span className="label">{t("pages.scan2pay.analysis.label3")}</span>
                            <span className="value">
                            <CountUp end={successPercent} duration={3}/>
                        </span>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AnalyticsCard;
